import { moveWindowToObj } from '../lib/lib'

class movieReminderLink {
  constructor(element) {
    if (!element) {
      return false
    }

    this.link = jQuery(element)

    this.link.on('click', (event) => {
      event.preventDefault()

      // Get the target element ID from the data attribute
      const id = jQuery(this.link).data('movie-reminder-id')


      // Scroll to the target element smoothly
      if (id) {
        jQuery(document).trigger('movie-reminder-clicked', id)        
      }
    })
  }
}

export default movieReminderLink